import React from 'react'
import cn from 'classnames'

import css from './Title.pcss'

type HTMLHeadingTags = 'h1' | 'h2' | 'h3'

interface Props {
	size?: '1' | '2' | '3'
	className?: string
}

const Title: React.FC<Props> = ({ size = '2', children, className }) => {
	const Tag = `h${size}` as HTMLHeadingTags
	const computedClassName = cn(css.title, css[`h${size}`], className)

	return <Tag className={computedClassName}>{children}</Tag>
}

export default Title
